import { render, staticRenderFns } from "./SalesProfitMarginsSupplier.vue?vue&type=template&id=9389d0c2&"
import script from "./SalesProfitMarginsSupplier.vue?vue&type=script&lang=js&"
export * from "./SalesProfitMarginsSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SalesProfitMarginsSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports